import { render } from "./TheLogo.vue?vue&type=template&id=433cc8eb"
import script from "./TheLogo.vue?vue&type=script&lang=js"
export * from "./TheLogo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__